module.exports = __webpack_public_path__ + "static/face-recognition-17c19e23da7b95fa33edfcfd5870bde7.gif";